import React from 'react';
import { Link } from 'react-router-dom';

class CheckinStatusGroup extends React.Component {
    render() {
        const { name, criteria } = this.props;

        return (
            <div className="CheckinStatusGroup">
                <div className="CheckinStatusGroup__title">
                    <span className="name">{name}</span>
                    <span className="count">{criteria.length}</span>
                </div>
                <div className="CheckinStatusGroup__criteria">
                    <ul>
                        {criteria.map(criterion => {
                            const criterionType =
                                criterion.type === 'NYS Required'
                                    ? 'NYSRequired'
                                    : criterion.type;
                            return (
                                <li
                                    key={criterion.id}
                                    className={criterionType}>
                                    <Link to={`/criterion/${criterion.id}`}>
                                        <div className="title">
                                            [{criterion.code}] {criterion.name}
                                        </div>
                                        <div className="meta">
                                            <span>Type</span>: {criterion.type}{' '}
                                            | <span>Scope</span>:{' '}
                                            {criterion.scope} |{' '}
                                            <span>Status</span>:{' '}
                                            {criterion.status}
                                        </div>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

export default CheckinStatusGroup;
